import React from 'react';
import { useLocation } from 'react-router-dom';
import { ITranslations } from '../../../i18n/config';
import EmailVerifyMessage from './EmailVerifyMessage';

interface EmailVerifySuccessProps {}

const EmailVerifySuccess: React.FC<EmailVerifySuccessProps> = () => {
  const { pathname } = useLocation();
  const copyIdentifier = React.useMemo(
    () => (pathname.indexOf('toevoegen') > 0 ? 'add' : 'update'),
    [pathname],
  );

  return (
    <EmailVerifyMessage
      type="success"
      pageTitle={`accessKeys.email.${copyIdentifier}.title` as ITranslations}
      pageDescription={`accessKeys.email.${copyIdentifier}.intro` as ITranslations}
      title={`accessKeys.verify.success.${copyIdentifier}.title` as ITranslations}
      summary={`accessKeys.verify.success.${copyIdentifier}.summary` as ITranslations}
      body="accessKeys.verify.success.body"
    />
  );
};

export default EmailVerifySuccess;
